export default async function downloadImageByUrl(imageSrc: string, fileName: string): Promise<void> {
  const image = await fetch(imageSrc);
  const imageBlog = await image.blob();
  const imageURL = URL.createObjectURL(imageBlog);
  const link = document.createElement('a');

  link.href = imageURL;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();

  setTimeout(() => {
    URL.revokeObjectURL(link.href);
  }, 1500);
}
